<template>
  <v-app-bar
    app
    color="primary"
    dark
    fixed
    height="56px"
    :src="$store.state.OPTIONS._app_background"
    hide-on-scroll
    fade-img-on-scroll
  >
    <template v-slot:img="{ props }">
      <v-img
        v-bind="props"
        gradient="to top, rgba(15, 149, 176,.4), rgba(15, 149, 176,.28)"
        position="top"
      ></v-img>
    </template>
    <v-app-bar-nav-icon
      @click="$store.commit('navDrawer')"
    ></v-app-bar-nav-icon>
    <v-toolbar-title>{{ $store.state.OPTIONS._app_title }}</v-toolbar-title>

    <v-spacer></v-spacer>

    <v-menu offset-y v-if="!/^\/application*/.test($route.path)">
      <template v-slot:activator="{ on, attrs }">
        <v-btn text v-on="on" v-bind="attrs"><v-icon class="mr-2" size="20">translate</v-icon>{{langTags[langKey]}}</v-btn>
      </template>
      <v-list dense>
        <v-list-item v-for="item in langMessages" :key="item" @click="setLang(item)">
          <v-list-item-title>{{langTags[item]}}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <template v-if="!/^\/application*/.test($route.path)" v-slot:extension>
      <v-tabs>
        <v-tab
          v-for="(tab, index) in tabs"
          :key="'TAB-' + index"
          :to="tab.to"
          >{{ $t(`navbar.${tab.name}`) }}</v-tab
        >
      </v-tabs>
    </template>
  </v-app-bar>
</template>
<script>
// router to menu.
const getMainRouterToMenu = () => {
  let routeArr = require("@/core/router/main.p.js");
  let menus = [];
  for (let i in routeArr.default.children) {
    let routeTabs = routeArr.default.children;
    if (routeTabs[i].meta)
      if (routeTabs[i].meta.menu.show)
        menus.push({
          to: routeTabs[i].path == "" ? "/" : routeTabs[i].path,
          name: routeTabs[i].meta.menu.name,
        });
  }
  return menus;
};
//////
export default {
  name: "Navbar",
  data() {
    return {
      searchBarFixed: false,
      tabs: getMainRouterToMenu(),
      langTags: this.$store.state.OPTIONS._local_lang.values,
      langKey: this.$store.state.OPTIONS._local_lang.type,
      langMessages: Object.keys(require("@/i18n/messages.js").default),
    };
  },
  created() {},
  mounted() {},
  methods: {
    setLang($lang) {
      this.$i18n.locale = $lang;
      this.$store.dispatch("setLang", $lang);
    },
  },
  destroyed() {},
};
</script>
